import React, { useEffect } from "react";
import { AssistantContextProvider } from "./components/assistant/AssistantContext";
import ProjectsPage2 from "./pages/ProjectsPage2";
import GuidedUpdateProjectPage from "./pages/GuidedUpdateProjectPage";
import "./app.scss";
import LoginPage from "./pages/LoginPage";
import { useDispatch, useSelector } from "react-redux";
import { loadCurrentUser } from "./components/user/usersAction";
import GlobalStyles from "./components/styles/GlobalStyles";
import StrategyPage from "./pages/StrategyPage";
import ObjectivesPage from "./pages/ObjectivesPage";
import SettingsPage from "./pages/SettingsPage";
import ActionsPage from "./pages/ActionsPage";

import {
  ACTIONS_ROUTE,
  GUIDED_UPDATE_PROJECT_WITH_ID_ROUTE,
  HOME_ROUTE,
  OKR_ROUTE,
  SETTINGS_ROUTE,
  USERS_ROUTE,
  ARCHIVE_ROUTE,
  MY_ACCOUNT,
  SECURITY,
  PASSWORD,
  DELETE_ACCOUNT,
  DASHBOARD_ROUTE,
  STRATEGY_ROUTE,
  PERSONALISATION_ROUTE,
  PITCH_STRATEGY_ROUTE,
  CALL_AGAIN_BOARD_ROUTES,
  ROADMAP_ROUTES,
  MEMBERS_BOARD_ROUTES,
  ENJOY_BOARD_ROUTE,
  ENJOY_NEWS_ROUTE,
  COACH_ENJOY_STRATEGY_ROUTE,
  EYBLEARNING_ROUTE,
} from "./routes/routesName";
import { Route, Routes } from "react-router-dom";
import UsersSection from "./components/user/UsersSection";
import AccountSecurity from "./components/account/AccountSecurity";
import ArchivedProjects from "./components/project/ArchivedProjects";
import NotFoundPage from "./pages/NotFoundPage";
import PitchProject from "./components/project/pitch/PitchProject";
import { useLocation } from "react-router";
import CurrentUserAccount from "./components/account/CurrentUserAccount";
import PasswordSection from "./components/account/PasswordSection";
import DeleteAccountSection from "./components/account/DeleteAccountSection";
import DashBoardsPage from "./pages/DashBoardsPage";
import Loader from "./components/progress-bar/Loader";
import { loadStrategy } from "./components/strategy/strategyAction";
import PitchStrategy from "./components/strategy/pitch_strategy/PitchStrategy";
import DashboardCallAgain from "./components/dashboard/DashboardCallAgain";
import RoadMap from "./components/dashboard/roadmap/RoadMap";
import DashboardByUser from "./components/dashboard/DashboardByUser";
import EnjoyBoard from "./components/dashboard/EnjoyBoard";
import EnjoyNewsPDF from "./components/enjoyNews/EnjoyNewsPDF";
import EnjoyCoachStrategy from "./components/assistant/enjoy-coach/EnjoyCoachStrategy";
import EnjoyNews from "./components/enjoyNews/EnjoyNews";
import EnjoyNewsPage from "./components/enjoyNews/EnjoyNewsPage";
import EYBLearningPage from "./pages/EYBLearningPage";
const App = () => {
  const dispatch = useDispatch();
  const { isLogin, token } = useSelector((state) => state.auth);
  const location = useLocation();
  const background = location?.state && location?.state?.background;

  useEffect(() => {
    const fetchUserData = async () => {
      if (token) {
        // Attend que l'utilisateur soit chargé avant de charger la stratégie
        await dispatch(loadCurrentUser());
        dispatch(loadStrategy());
      }
    };

    fetchUserData();
  }, [dispatch, token]);

  const sections = () => {
    if (!token) {
      return (
        <>
          <GlobalStyles />
          <LoginPage />
        </>
      );
    } else {
      if (isLogin) {
        return (
          <>
            <GlobalStyles />
            <React.Suspense fallback={<Loader />}>
              <AssistantContextProvider>
                <Routes>
                  <Route path={HOME_ROUTE} element={<ProjectsPage2 />}>
                    <Route path={MY_ACCOUNT} element={<CurrentUserAccount />} />
                    <Route path={"projets"}>
                      <Route path={":projectId"} element={<PitchProject />} />
                    </Route>
                  </Route>
                  <Route path={OKR_ROUTE} element={<ObjectivesPage />}>
                    <Route path={MY_ACCOUNT} element={<CurrentUserAccount />} />
                  </Route>
                  <Route path={ACTIONS_ROUTE} element={<ActionsPage />}>
                    <Route path={MY_ACCOUNT} element={<CurrentUserAccount />} />
                  </Route>
                  <Route
                    path={GUIDED_UPDATE_PROJECT_WITH_ID_ROUTE}
                    element={<GuidedUpdateProjectPage />}
                  />
                  <Route path={STRATEGY_ROUTE} element={<StrategyPage />}>
                    <Route path={MY_ACCOUNT} element={<CurrentUserAccount />} />
                    <Route path={":projectId"} element={<PitchProject />} />
                  </Route>
                  <Route path={COACH_ENJOY_STRATEGY_ROUTE} element={<EnjoyCoachStrategy /> } />
                  <Route path={DASHBOARD_ROUTE} element={<DashBoardsPage />} />
                  <Route path={DASHBOARD_ROUTE} element={<DashBoardsPage />}>
                    <Route
                      path={PITCH_STRATEGY_ROUTE}
                      element={<PitchStrategy />}
                    />
                    <Route
                      path={CALL_AGAIN_BOARD_ROUTES}
                      element={<DashboardCallAgain />}
                    />
                    <Route path={ROADMAP_ROUTES} element={<RoadMap />} />
                    <Route
                      path={MEMBERS_BOARD_ROUTES}
                      element={<DashboardByUser />}
                    />
                    <Route path={ENJOY_BOARD_ROUTE} element={<EnjoyBoard />} />
                    <Route path={MY_ACCOUNT} element={<CurrentUserAccount />} />
                    <Route path={":projectId"} element={<PitchProject />} />
                  </Route>
                  <Route path={ENJOY_NEWS_ROUTE} element={<EnjoyNewsPDF/>}/>
                  <Route path={"/ENpreview"} element={<EnjoyNewsPage/>}/>
                  <Route path={EYBLEARNING_ROUTE} element={<EYBLearningPage/>}/>
                  <Route path={SETTINGS_ROUTE} element={<SettingsPage />}>
                    <Route path={MY_ACCOUNT} element={<CurrentUserAccount />} />
                    <Route path={USERS_ROUTE} element={<UsersSection />} />
                    <Route path={SECURITY} element={<AccountSecurity />}>
                      <Route path={PASSWORD} element={<PasswordSection />} />
                      <Route
                        path={DELETE_ACCOUNT}
                        element={<DeleteAccountSection />}
                      />
                    </Route>
                    <Route
                      path={ARCHIVE_ROUTE}
                      element={<ArchivedProjects />}
                    />
                    <Route
                      path={PERSONALISATION_ROUTE}
                      element={<PERSONALISATION_ROUTE />}
                    />
                    <Route path="*" element={<NotFoundPage />} />
                  </Route>
                  <Route path="*" element={<NotFoundPage />} />
                </Routes>
              </AssistantContextProvider>
              {background && <CurrentUserAccount />}
            </React.Suspense>
          </>
        );
      } else {
        return <Loader />;
      }
    }
  };

  return <div className="App">{sections()}</div>;
};

export default App;
